// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/assets/css/base.css'
import JsEncrypt from 'jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt
Vue.config.productionTip = false
Vue.use(Vant);

import { getServerConfig } from '@/utils/permission'
// 请求文件内容及创建实例
async function main () {

  //正式环境
  //await getServerConfig("/address1/address2/wxuser/getuserinfo2",'houtai');
  //测试环境
  await getServerConfig("/address/wxuser/getuserinfo2",'houtai');


  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}
// 方法初始执行
main();




// WEBPACK FOOTER //
// ./src/main.js